import styled from 'styled-components';
import { Title } from '@lux/title';
export const Heading = styled(Title) `
    margin: 15px 0 12px;
    padding: 0;
    text-transform: none;
`;
export const Wrapper = styled.div `
    text-align: center;
    box-sizing: border-box;
    height: 100%;
    position: relative;
    padding: ${props => `${props.closable ? 0 : 32}px 20px 32px`};
`;
//# sourceMappingURL=styles.js.map